import BaseApi from "@/core/HttpResources/BaseApi";

export default class AreaService {
  baseApiPublish = new BaseApi("Areas");
   GetArea(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAllHistoryAreas",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  GetHistoryArea(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetHistoryAreas",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  GetNotHistoryArea(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetNotHistoryHAreas",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}